import PropTypes from "prop-types";
import classnames from "classnames";

const Definition = ({ term, definition, tableContent }) => {
  return (
    <div
      className={classnames("definitions__terminology", {
        "definitions__terminology-table": tableContent,
      })}
    >
      <div className="definitions__body-term-wrapper">
        <h4 className="definitions__body-term-heading">{term}</h4>
      </div>
      {definition && (
        <div className="definitions__body-item-content">{definition}</div>
      )}
      {tableContent && (
        <div className="definitions__table-wrapper">
          <table className="table definitions__table" role="grid">
            <tbody>
              <tr role="row" className="definitions__table--header">
                {tableContent.columns.map(({ label }, index) => (
                  <th key={index} role="columnheader" scope="col">
                    {label}
                  </th>
                ))}
              </tr>
              {tableContent.lists?.map((item, index) => (
                <tr key={index} role="row">
                  <td role="gridcell">{item.aaa}</td>
                  <td role="gridcell">{item.aa}</td>
                  <td role="gridcell">{item.a}</td>
                  <td role="gridcell">{item.bbb}</td>
                  <td role="gridcell">{item.bb}</td>
                  <td role="gridcell">{item.b}</td>
                  <td role="gridcell">{item.ccc}</td>
                  <td role="gridcell">{item.cc}</td>
                  <td role="gridcell">{item.c}</td>
                  <td role="gridcell">{item.d}</td>
                  <td role="gridcell">{item.nr}</td>
                </tr>
              ))}
              {tableContent.columnContent && (
                <tr role="row" className="column-content">
                  {tableContent.columnContent.map((item, index) => (
                    <td
                      key={index}
                      colSpan="3"
                      role="gridcell"
                      className="gridcell"
                    >
                      <div className={`gridcell--${item.title.toLowerCase()}`}>
                        {item.title}
                      </div>
                      <div className="gridcell--description">
                        {item.description}
                      </div>
                    </td>
                  ))}
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

Definition.propTypes = {
  term: PropTypes.string.isRequired,
  definition: PropTypes.node,
  tableContent: PropTypes.shape({
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        key: PropTypes.string.isRequired,
      })
    ),
    lists: PropTypes.arrayOf(
      PropTypes.shape({
        aaa: PropTypes.string,
        aa: PropTypes.string,
        a: PropTypes.string,
        bbb: PropTypes.string,
        bb: PropTypes.string,
        b: PropTypes.string,
        ccc: PropTypes.string,
        cc: PropTypes.string,
        c: PropTypes.string,
        d: PropTypes.string,
        nr: PropTypes.string,
      })
    ),
  }),
};

export default Definition;
